let locales = {
    cancel: "Cancelar",
    send: "Enviar",
    save: "Guardar",
    desactivated: "Desactivado",
    active: "Activo",
    voluntary_suspension: "Suspensión voluntaria",
    involuntary_suspension: "Suspensión involuntaria",
    cancelled: "Cancelado",
    rma: "RMA",
    inactive: "Inactivo",

    //Menu - Sidebar
    menu_accounts: "Cuentas",
    menu_devices: "Dispositivos",
    menu_vidfleet: "Vidfleet",
    menu_settings: "Configuración",
    menu_user_activity_logs: "Registros de Actividad de los Usuarios",
    menu_key_fobs: "Llaveros",
    menu_maintenance_warnings: "Advertencias de mantenimiento",
    menu_camera_logs: "Registros de la cámara",
    menu_dms_statuses: "Estados del DMS",
    menu_power_lost: "Pérdida de potencia",
    menu_sd_card_status: "Estado de la tarjeta SD",
    menu_white_listed_devices: "Dispositivos listados en blanco",
    menu_packages: "Paquetes",
    menu_pm_users: "Usuarios de PM",
    menu_jira_summary: "Resumen Jira",
    manufacturers: "Fabricantes",
    menu_reports: "Reportes",
    menu_cloud_lg_page: "Página de acceso a la nube",
    menu_dashboard: "Consola",
    menu_alert_types: "Tipos de alerta",
    menu_transactions: "Transaccioness",
    menu_events: "Eventos",
    menu_sim_provider: "Proveedores SIM",
    menu_sim_provider_accounts: "Cuentas de proveedores SIM",
    menu_sim_sms_systems: "Sistemas SMS",
    menu_dealers: "Distribuidores",
    menu_bulk_sms: "SMS masivos",
    menu_firmwares_reviews: "Firmwares",
    menu_brands: "Marcas",
    menu_video_review: "Revisiones de Video IA",

    //Menu - Account
    menu_account_change_password: "Cambiar la contraseña",
    menu_account_clear_caches: "Limpiar cachés",
    menu_account_temp_token: "Token temporal",
    menu_account_logout: "Cerrar la sesión",
    menu_account_account: "Cuenta",
    menu_scheduled_actions: "Acciones programadas",
    menu_unsubscribed_contacts: "Contactos dados de baja",
    menu_unsubscribed_warnings: "Advertencias",
    menus_accounts_tags: "Etiquetas",
    menu_migrations: "Migraciones",

    advanced_filters: "Filtros avanzados",

    //forms
    required_field: "Campo Requerido",
    density: "Densidad",
    refresh: "Refrescar",
    search: "Buscar",
    export: "Exportar",
    changeColumnOrder: "Cambiar el orden de las columnas",
    exportCSV: "Exportar a CSV todas las columnas",
    exportCSVVisible: "Exportar a CSV las columnas visibles",
    exportPDF: "Exportar a PDF",
    delete: "Eliminar",
    today: "Hoy",
    day: "Día",
    yerterday: "Ayer",
    this_week: "Esta semana",
    last_week: "Última semana",
    this_month: "Este mes",
    last_month: "Último mes",
    this_quarter: "Este trimestre",
    last_quarter: "Último trimestre",
    edit: 'Editar',
    close: 'Cerrar',
    activate: 'Activar',
    desactivate: 'Desactivar',
    custom: "Personalizado",
    email_is_invalid: "El correo electrónico no es válido",

    //common
    common_copied: "Copiado",
    common_from: "Desde",
    common_to: "Hasta",
    common_cancel: "Cancelar",
    common_field_required: "Campo Requerido",
    common_enabled: "Habilitado",
    common_disabled: "Deshabilitado",
    common_on: "Encendido",
    common_off: "Apagado",
    common_warning: "Advertencia",
    common_emergency: "Emergencia",
    common_next: "Siguiente",
    common_back: "Atras",
    common_add: "Agregar",
    common_reset: "Restablecer",
    common_no_devices_added: "No hay dispositivos añadidos",
    common_no_keyfobs_added: "No hay llaveros añadidos",
    common_no_accounts_added: "No hay cuentas añadidas",
    common_active: "Activo",
    common_inactive: "Inactivo",
    error_password: "La contraseña debe tener al menos un número, una minúscula y una mayúscula",
    no_devices_added: "No se han añadido dispositivos",
    common_no_information_to_display: "No hay información que mostrar",
    common_authentication_failed: "Fallo de autentificación",
    common_camera_password_error: "Error en la contraseña de la cámara",
    common_camera_operation_failed: "Fallo en el funcionamiento de la cámara",
    common_camera_does_not_exist: "La cámara no existe",
    common_sync_camera_error: "Error de sincronización de la cámara",
    common_close: "Cerrar",
    common_show: "Mostrar",
    common_save: "Guardar",
    common_error_permission: "No tiene los permisos necesarios para realizar esta acción.",
    export_message: "Su archivo se generará en un momento",
    very_weak: "Muy débil",
    weak: "Débil",
    fair: "Justa",
    good: "Buena",
    strong: "Fuerte",
    actions: "Acciones",
    select: "Seleccionar",
    nextp: "siguiente",
    prev: "anterior",
    perPage: "por página",
    no_options: "Sin opciones",
    split: "Dividir",
    no_split: "Sin división ",
    no_more_items: "No hay más elementos",

    // DataView ARIA accessibility messages
    common_dataview_aria_loading: "Cargando datos...",
    common_dataview_aria_loading_more: "Cargando más elementos...",
    common_dataview_aria_error: "Error",
    common_dataview_aria_showing_items: "Mostrando {count} elementos",
    common_dataview_aria_table_region: "Tabla de datos",
    common_dataview_aria_table_label: "Tabla de datos con columnas ordenables",
    common_dataview_aria_column_moved_left: "Columna {column} movida a la izquierda",
    common_dataview_aria_column_moved_right: "Columna {column} movida a la derecha",
    common_dataview_aria_drag_to_reorder: "Arrastrar para reordenar columna",
    english_label: "Inglés",
    spanish_label: "Español",
    common_new: "Nuevo",
    common_old: "Viejo",
    common_yes: "Si",
    common_no: "No",
    common_show_changes: "Mostrar cambios",
    common_remove: "Eliminar",
    common_edit_assign: "Editar asignaciones",
    common_contract: "Contraer",
    common_expand: "Ampliar",
    common_loading: "Cargando",
    common_copy: "Copiar",
    common_clear: "Limpiar",
    common_continue: "Continuar",
    common_changes: "Cambios",
    common_unit_time: "Hora de la Unidad",
    common_server_time: "Hora del servidor",
    Dealer: "Distribuidor",
    Network: "Red",
    Manufacturer: "Fabricante",
    "Device Model": "Modelo de dispositivo",
    "Asset Type": "Tipo de activo",
    "Offline Days": "Días sin conexión",
    Warning: "Alerta",
    Date: "Fecha",
    Permission: "Permiso",
    Report: "Reporte",
    lastEventName: "Nombre del último evento",
    simType: "Tipo de Sim",
    manufacturer: "Fabricante",
    events: "Eventos",
    common_now: "Ahora",
    common_schedule: "Programar",
    common_executed: "Ejecutado",
    common_not_executed: "Programado",
    common_error_format: "El formato no es correcto",
    common_hour: "Hora",
    common_mins: "Mins",
    common_seconds: "Segundos",
    common_set: "Aplicar",
    common_hour_no_valid: "Hora no válida",
    common_resend: "Reenviar",
    common_change: "Cambiar",
    common_untagged: "Sin etiquetar",
    common_download: "Descargar",
    common_accept: "Aceptar",
    //new
    pmexportlogs: "Registros de Exportación PM",
    scheduledreports: "Informes Programados",
    systemalertlog: "Registro de Alertas del Sistema",
    accounts: "Cuentas",
    activities: "Actividades",
    useractivitylogs: "Registros de Actividad de los Usuarios",
    alerttypes: "Tipos de alerta",
    devicesreadings: "Lectura de Dispositivos",
    maintenancewarnings: "Advertencias de Mantenimiento",
    commands: "Comandos",
    notes: "Notas",
    calampfiles: "Archivos Calamp",
    devices: "Dispositivos",
    troubleshootingevents: "Resolución de Problemas",
    usertroubleshooting: "Solución de Problemas del Usuario",
    importp4: "Importación P4",
    importaccount: "Importación de Cuenta",
    keyfobs: "Llaveros",
    cannedcommands: "Comandos Predefinidos",
    devicemodels: "Modelos de Dispositivos",
    firmwares: "Firmwares",
    partnumbers: "Números de Piezas",
    unittypes: "Tipos de Unidades",
    unittypeevents: "Tipo de Unidad Eventos",
    manufacturers: "Fabricantes",
    assignedto: "Asignado a",
    packages: "Paquetes",
    jirasummary: "Resumen de Jira",
    pmusers: "PM Usuarios",
    rawdata: "Datos Brutos",
    reports: "Reportes",
    scheduledactions: "Acciones Programadas",
    sim_provideraccounts: "Cuentas de proveedores Sim",
    simproviders: "Proveedores de Sim",
    smssystems: "Sistemas SMS",
    transactionsdetails: "Detalles de la Transacción",
    transactionsrequests: "Solicitudes de Transacciones",
    transactionsresults: "Resultados de las Transacciones",
    unsubscribedcontacts: "Contactos no Suscritos",
    users: "Usuarios",
    changeshistory: "Historial de Cambios",
    cameralogs: "Registros de Cámaras",
    dmsstatuses: "Estados DMS",
    powerlost: "Pérdida de Potencia",
    sdcardstatuses: "Estados SDCARD",
    whitelisteddevices: "Dispositivos Listados en Blanco",
    statusUpdate: "Cambio de Estado",
    Active: "Activo",
    Pending: "Pendiente",
    Expired: "Expirado",
    "Voluntary Suspension": "Suspensión Voluntaria",
    "Involuntary Suspesion": "Suspesión Involuntaria",
    Cancelled: "Cancelled",
    insert: "Agregar",
    update: "Editar",
    delete: "Eliminar",
    other: "Otros",
    "Card Number": "Número de Tarjeta",
    completed: "Completado",
    fail: "Error",
    "Date Range": "Rango de Fechas",
    sent: "Enviado",
    pending: "Pendiente",
    command: "Comando",
    accepted: "Aceptado",
    rejected: "Rechazado",
    emailRecipients: "Destinatarios de correo",
    recipients: "Destinatarios",
    smsIntegrationId: "Id. de integración de Sms",
    mass_sms_request_has_ended: "La petición de sms masivos ha finalizado. Haga clic aquí para ver el estado",
    mass_sms_request_has_been_received: "La petición de sms masivos ha sido recibida. Haga clic aquí para ver el estado",
    package_premium: "PREMIUM",
    package_advanced: "AVANZADO",
    package_basic: "BASICO",
    noMoreItems: "No hay más elementos.",
    // RQ-ERR-06: ErrorIndicator messages for infinite scroll
    common_dataview_error_loading_more: "Error al cargar más elementos. Por favor, intente de nuevo.",
    common_dataview_retry: "Reintentar",
    failed: "Fallido",
    complete: "Completo",
    failure: "Fallo",

    //months list
    month_jan: "ENE",
    month_feb: "FEB",
    month_mar: "MAR",
    month_apr: "APR",
    month_may: "MAY",
    month_jun: "JUN",
    month_jul: "JUL",
    month_aug: "AGO",
    month_sep: "SEP",
    month_oct: "OCT",
    month_nov: "NOV",
    month_dec: "DIC",
    untagged: "Sin etiquetar",
    start_typing_to_search: "Empieza a escribir para buscar",

    //videoEvents Helpers
    video_event_type_asleep: "Dormido",
    video_event_type_drivingHit: "Parada repentina",
    video_event_type_dayDreaming: "Sueño diurno",
    video_event_type_distracted: "Distraído",
    video_event_type_drowsy: "Somnoliento",
    video_event_type_hardAccel: "Aceleración rápida",
    video_event_type_hardBrake: "Freno duro",
    video_event_type_sharpTurn: "Giro brusco",
    video_event_type_manual: "Manual",
    video_event_type_noSeatBelt: "Sin cinturón de seguridad",
    video_event_type_smoking: "Fumando",
    video_event_type_usingPhone: "Usando el teléfono",
    video_event_type_yawn: "Bostezo",
    video_event_type_collisionWarning: "Aviso de colisión",
    video_event_type_laneDeparture: "Salida de carril",
    video_event_type_closeFollowing: "Aviso de proximidad",
    video_event_type_tailgating: "Emergencia de proximidad",
    video_event_type_stopSignViolation: "Violación de señal de stop",
    video_event_type_noDriver: "Cámara obstruida",
    video_event_type_idleNoDriver: "Inactiva sin conductor",
    video_event_type_potentialIncident: "Incidente potencial",
    video_event_type_passengerInside: "Pasajero dentro",
    video_event_type_potentialIncidentMedium: "Incidente potencial medio",

    boolean_true: "Verdadero",
    boolean_false: "Falso",

    common_remove: "Remover",
    common_pending: "Pendiente",
    common_in_progress: "En Progreso",
    common_done: "Terminado",
    common_done_with_errors: "Terminado con Errores",
    common_failed: "Fallido",

    // DataViewInfiniteScroll - Empty States
    common_dataview_empty_initial: "Selecciona tus filtros para buscar tus elementos",
    common_dataview_empty_no_data: "No hay elementos disponibles",
    common_dataview_empty_filtered: "Ningún resultado coincide con tus filtros",
    common_dataview_empty_search: "No se encontraron resultados para tu búsqueda",
    common_dataview_empty_error: "No se pudo cargar los datos",

    // DataViewInfiniteScroll - Selection
    common_dataview_selection_limit_reached: "Límite máximo de selección alcanzado ({max} elementos)",
    common_dataview_selection_limit_title: "Límite de Selección",
    common_dataview_selection_limit_exceeded: "Selección limitada a {max} elementos. {excess} elementos no fueron seleccionados.",
    common_dataview_selection_limit_tooltip: "No se pueden seleccionar más elementos. Máximo {max} elementos permitidos.",
    common_dataview_search_limit_reached: "Búsqueda limitada a {max} elementos. Elimine algunos para agregar nuevos.",
    common_dataview_search_limit_title: "Límite de Búsqueda",

    // DataViewInfiniteScroll - UI Labels
    common_dataview_drag_to_reorder: "Arrastra para reordenar columna",
    common_dataview_total_label: "Total",

}

import security from 'Core/.globals/lan/es';
import accounts from 'Modules/accounts/.globals/lan/es';
import dealers from 'Modules/dealers/.globals/lan/es';
import devices from 'Modules/devices/.globals/lan/es';
import keysFobs from 'Modules/keysFobs/.globals/lan/es';
import users from 'Modules/users/.globals/lan/es';
import activities from 'Modules/activities/.globals/lan/es';
import pmUsers from 'Modules/pmUsers/.globals/lan/es';
import packages from 'Modules/packages/.globals/lan/es';
import rawData from 'Modules/rawData/.globals/lan/es';
import vidfleet from 'Modules/vidfleet/.globals/lan/es';
import transactions from 'Modules/transactions/.globals/lan/es';
import commonModules from '../../../modules/.common/.components/vidfleetInformation/lan/es';
import manufacturers from 'Modules/manufacturers/.globals/lan/es';
import reports from 'Modules/reports/.globals/lan/es';
import importP4 from 'Modules/importP4/.globals/lan/es';
import importAccount from 'Modules/importAccount/.globals/lan/es';
import loginPage from 'Modules/loginPage/.globals/lan/es';
import dashboard from 'Modules/dashboard/.globals/lan/es';
import alertTypes from 'Modules/alertTypes/.globals/lan/es';
import scheduledActions from 'Modules/scheduledActions/.globals/lan/es';
import events from 'Modules/events/.globals/lan/es';
import unsubscribedContacts from 'Modules/unsubscribedContacts/.globals/lan/es';
import simProviders from 'Modules/simProviders/.globals/lan/es';
import simProviderAccounts from 'Modules/simProviderAccounts/.globals/lan/es';
import smsSystems from 'Modules/smsSystems/.globals/lan/es';
import maintenanceWarningEvents from 'Modules/maintenanceWarningEvents/.globals/lan/es';
import tags from 'Modules/tags/.globals/lan/es';
import brands from 'Modules/brands/.globals/lan/es';
import resetPassword from 'Modules/.common/.components/resetPassword/lan/es';
import resetEmail from 'Modules/.common/.components/resetEmail/lan/es';
import resendInvite from 'Modules/.common/.components/resendInvite/lan/es';



locales = {
    ...locales,
    ...security,
    ...accounts,
    ...dealers,
    ...devices,
    ...keysFobs,
    ...users,
    ...activities,
    ...pmUsers,
    ...packages,
    ...rawData,
    ...vidfleet,
    ...transactions,
    ...commonModules,
    ...manufacturers,
    ...reports,
    ...importP4,
    ...importAccount,
    ...loginPage,
    ...dashboard,
    ...alertTypes,
    ...scheduledActions,
    ...events,
    ...unsubscribedContacts,
    ...simProviders,
    ...simProviderAccounts,
    ...smsSystems,
    ...maintenanceWarningEvents,
    ...tags,
    ...brands,
    ...resetPassword,
    ...resetEmail,
    ...resendInvite,
}

export default locales;